<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" class="icon">
    <g>
      <path
        style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Bitstream Vera Sans"
        d="M 24.875 0 A 1.0001 1.0001 0 0 0 24.0625 0.625 L 17.8125 16.125 L 1.15625 17.28125 A 1.0001 1.0001 0 0 0 0.59375 19.03125 L 13.40625 29.75 L 9.34375 45.96875 A 1.0001 1.0001 0 0 0 10.84375 47.0625 L 25 38.1875 L 39.15625 47.0625 A 1.0001 1.0001 0 0 0 40.65625 45.96875 L 36.59375 29.75 L 49.40625 19.03125 A 1.0001 1.0001 0 0 0 48.84375 17.28125 L 32.1875 16.125 L 25.9375 0.625 A 1.0001 1.0001 0 0 0 24.875 0 z M 25 3.71875 L 30.53125 17.46875 A 1.0001 1.0001 0 0 0 31.40625 18.09375 L 46.1875 19.09375 L 34.8125 28.625 A 1.0001 1.0001 0 0 0 34.5 29.65625 L 38.125 44.0625 L 25.53125 36.15625 A 1.0001 1.0001 0 0 0 24.46875 36.15625 L 11.875 44.0625 L 15.5 29.65625 A 1.0001 1.0001 0 0 0 15.1875 28.625 L 3.8125 19.09375 L 18.59375 18.09375 A 1.0001 1.0001 0 0 0 19.46875 17.46875 L 25 3.71875 z"
        overflow="visible"
        enable-background="accumulate"
        font-family="Bitstream Vera Sans"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "star",
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
